import React from 'react';
import { SearchFilterContent } from './searchFilterContent';
import { SearchFilterNarrowContent } from './searchFilterNarrowContent';
import { LocationOptions } from '../../../../../utils';

export interface SearchFilterProps {
  date: Date | null | undefined;
  locationId: string;
  locationList: LocationOptions[];
  narrowWidth: boolean;
  filterChanged: (date: Date | null | undefined, locationId: string) => void;
}

const SearchFilter: React.FC<SearchFilterProps> = (
  props: SearchFilterProps
) => {
  const showLocationOptions =
    props.locationList && props.locationList.length > 1;

  return (
    <>
      {props.narrowWidth && showLocationOptions ? (
        <SearchFilterNarrowContent
          date={props.date}
          locationId={props.locationId}
          showLocationOptions={showLocationOptions}
          locationList={props.locationList}
          filterChanged={props.filterChanged}
        />
      ) : (
        <SearchFilterContent
          date={props.date}
          locationId={props.locationId}
          showLocationOptions={showLocationOptions}
          locationList={props.locationList}
          filterChanged={props.filterChanged}
        />
      )}
    </>
  );
};

export default SearchFilter;
